import { Component, OnDestroy, OnInit } from "@angular/core";
import { EventsService } from "../../../_services/eventsServices/events.service";

import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { ParentQuestion } from "../event-page-models/parent-question";

@Component({
  selector: "create-parent-event-form-parent-questions",
  templateUrl: "./create-parent-event-form-parent-questions.component.html",
  styleUrls: ["./create-parent-event-form-parent-questions.component.scss"],
})
export class CreateParentEventFormParentQuestionsComponent
  implements OnInit, OnDestroy
{
  public readonly $parentQuestions: BehaviorSubject<ParentQuestion[]> =
    new BehaviorSubject<ParentQuestion[]>([]);
  public firstQuestion: ParentQuestion;
  public activeCard: ParentQuestion | null;

  constructor(private eventsService: EventsService) {
    this.getAllQuestions();
  }

  public ngOnInit(): void {}

  ngOnDestroy(): void {}

  public isCardActive(card: ParentQuestion): boolean {
    return card === this.activeCard;
  }

  public setActiveCard($event: ParentQuestion) {
    this.activeCard = $event;
  }

  public addNewQuestion() {
    this.eventsService.addNewQuestion();
  }

  private getAllQuestions(): void {
    this.eventsService
      .getAllQuestions()
      .subscribe((events: ParentQuestion[]) => {
        this.$parentQuestions.next(events);
        this.firstQuestion = events[0];
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/create-parent-event-form-parent-questions/create-parent-event-form-parent-questions.component.ts